import React from 'react';
import { createPortal } from 'react-dom';
import styles from './DependencyModal.module.css';

const DependencyModal = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  primaryButton, 
  secondaryButton = null 
}) => {
  if (!isOpen) return null;

  // Proper styled modal with dark futuristic theme
  const modalContent = (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex: 999999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          backgroundColor: '#2d2d2d',
          padding: '24px',
          borderRadius: '8px',
          width: '90%',
          maxWidth: '500px',
          boxShadow: '0 8px 16px rgba(0,0,0,0.5)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            color: '#e0e0e0',
            cursor: 'pointer'
          }}
          onClick={onClose}
        >
          ×
        </button>
        
        <h2 style={{ 
          margin: '0 0 16px 0', 
          color: '#e0e0e0', 
          fontSize: '20px' 
        }}>
          {title}
        </h2>
        
        <p style={{ 
          margin: '16px 0', 
          color: '#ddd', 
          fontSize: '14px', 
          lineHeight: '1.5', 
          textAlign: 'center' 
        }}>
          {message}
        </p>
        
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          gap: '8px',
          marginTop: '16px'
        }}>
          <button 
            style={{
              backgroundColor: 'transparent',
              border: '1px solid #555',
              color: '#e0e0e0',
              padding: '8px 16px',
              fontSize: '14px',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#333';
              e.target.style.borderColor = '#888';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#555';
            }}
          >
            Cancel
          </button>
          
          <button 
            style={{
              backgroundColor: '#333',
              border: '1px solid #555',
              color: '#e0e0e0',
              padding: '8px 16px',
              fontSize: '14px',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onClick={() => {
              if (primaryButton.onClick) {
                primaryButton.onClick();
              }
              onClose();
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#444';
              e.target.style.borderColor = '#2196f3';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#333';
              e.target.style.borderColor = '#555';
            }}
          >
            {primaryButton.text}
          </button>
        </div>
      </div>
    </div>
  );

  // Use React Portal to render modal at document.body level (outside any containers)
  return createPortal(modalContent, document.body);
};

export default DependencyModal;